import { render, staticRenderFns } from "./TraxTrainingRatingCrud.vue?vue&type=template&id=5431ccf2"
import script from "./TraxTrainingRatingCrud.vue?vue&type=script&lang=js"
export * from "./TraxTrainingRatingCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports